import styled from 'styled-components';

const LinearProgressBarWrapper = styled.div`
  width: 100%;
`;

const ProgressVisualWrapper = styled.div`
  border-radius: var(--size-border-radius-md);
  display: flex;
  height: 6px;
  margin: 12px 0;
`;

const ProgressVisualPart = styled.div`
  border-radius: var(--size-border-radius-md);
  transition: width 1s;
`;

export { LinearProgressBarWrapper, ProgressVisualPart, ProgressVisualWrapper };
